import './jquery-global';
import 'bootstrap/dist/js/bootstrap.js';
import {_} from 'lodash';
import {ko} from './knockout-global';
import './vendor/knockout-switch-case.esm';
import './knockoutBindings';
import * as constants from './constants';
import {SNACKBAR_DURATION_SHORT, WIN_NAME_APP, WIN_NAME_DOCS, WIN_NAME_IFRAME} from './constants';
import {getHash, getRouteDefinition, isRoutePermissionOkay} from './constants/RouteDefinitions';
import * as language from './constants/Language';
import * as utils from './util/misc';
import {nsTooltip} from './util/nsTooltip';
import * as c from './constants/AllConstants';
import {nsSync} from './util/nsSync';
import {nsLanguage} from './util/nsLanguage';
import {config, global, lm, lm_} from './appContext';
import {storeObservable} from './util/sessionstore';
import {wireDebugConsole} from './util/debugConsole';
import {installEsmComponentLoader} from './componentLoader';

wireDebugConsole(storeObservable('should.use.console'));

const isIframe = /\/win.html/g.test(document.location.pathname);
window.name = isIframe ? WIN_NAME_IFRAME : WIN_NAME_APP;

installEsmComponentLoader();

const bindingContext = {
    $t: lm.$t.bind(lm),
    WIN_NAME_DOCS: WIN_NAME_DOCS,
    WIN_NAME_IFRAME: WIN_NAME_IFRAME,
    c: c,
    config: config,
    constants: constants,
    getRouteDefinition: getRouteDefinition,
    global: global,
    language: language,
    lm: lm,
    lm_: lm_,
    nsLanguage: nsLanguage,
    nsSync: nsSync,
    nsTooltip: nsTooltip,
    t: lm.t.bind(lm),
    tc: lm.tc.bind(lm),
    utils: _.extend({}, utils, {getHash, isRoutePermissionOkay}),
};
ko.applyBindings(bindingContext, document.getElementById('root'));

Promise.resolve()
    .then(() => config.init())
    










    .then(() => global.init());

jQuery(document).on('click.bs.dropdown.data-api', '.keep-inside-clicks-open', function (e) {
    if (!(e.target as HTMLElement).closest('.dispatch-clicks')) {
        e.stopPropagation();
    }
});

let __resizingTableHeaders: HTMLElement[] | null = null;

document.documentElement.addEventListener('mousedown', (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (target.tagName.toUpperCase() == 'TH' && getComputedStyle(target).resize == 'horizontal') {
        const parentElement = target.parentElement;
        if (!parentElement) {
            return true;
        }
        const children = [...(parentElement.children as any)].filter(
            (o) => o.style && getComputedStyle(o).display != 'none' && getComputedStyle(o).resize == 'horizontal',
        );
        __resizingTableHeaders = children;
        const index = children.indexOf(target);
        children.forEach((el: HTMLElement) => {
            __addStyleWidth(el, true);
        });
        if (index < children.length - 1) {
            __removeStyleWidth(children[index + 1]);
        }
    }
    return true;
});

window.addEventListener('mouseup', (e: MouseEvent) => {
    if (__resizingTableHeaders) {
        __resizingTableHeaders.forEach((o) => {
            __addStyleWidth(o, false);
        });
        __resizingTableHeaders = null;
    }
    return true;
});

function __addStyleWidth(el: HTMLElement, pixels: boolean) {
    const width = el.getBoundingClientRect().width;
    if (pixels) {
        el.style.width = width + 'px';
    } else {
        const parentElement = el.parentElement;
    if (!parentElement) {
        return;
    }
    const total = parentElement.getBoundingClientRect().width;
        const percent = (width / total) * 100;
        el.style.width = percent + '%';
    }
}

function __removeStyleWidth(el: HTMLElement) {
    if (!el.style) {
        return;
    }
    el.style.width = 'initial';
}

document.addEventListener(
    'click',
    (event: MouseEvent) => {
        if (!global?.pv?.superAdmin()) {
            return true;
        }
        if (!event.altKey) return true;
        event.preventDefault();
        event.stopImmediatePropagation();
        let target = event.target as HTMLElement | null;
        while (target && target !== document.documentElement) {
            const bindings = ko.bindingProvider.instance.getBindings(target, ko.contextFor(target)) as any;
            if (bindings?.t) {
                target.style.outline = '1px dashed blue';
                if ((target as any).__translationHighlightTimeout) {
                    clearTimeout((target as any).__translationHighlightTimeout);
                }
                (target as any).__translationHighlightTimeout = setTimeout(
                (target as HTMLElement).style.outline = '',
                    SNACKBAR_DURATION_SHORT,
                );
                const label = utils.getAnyValue(bindings?.t?.k ?? bindings?.t);
                console.group(label);
                console.log(
                    bindings?.t?.obj ? bindings?.t?.obj : `(no translation object parameter)`,
                );
                console.groupEnd();
                break;
            }
            target = target.parentElement;
        }
    },
    true,
);
